<template>
  <v-container fluid class="pa-0">
    <v-text-field
      v-model="newPassword"
      :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
      filled
      dense
      :rules="[obligatoireRule(), passwordRule]"
      :type="show2 ? 'text' : 'password'"
      :label="$t('password.changeDialog.password')"
      @click:append="show2 = !show2"
      v-on:input="password_check"
      autocomplete="off"
    />

    <br />
    <v-text-field
      v-model="confirmNewPassword"
      :append-icon="show3 ? 'mdi-eye' : 'mdi-eye-off'"
      filled
      dense
      :rules="[obligatoireRule(), confirmationRule]"
      :type="show3 ? 'text' : 'password'"
      :label="$t('password.changeDialog.confirm')"
      @click:append="show3 = !show3"
      autocomplete="new-password"
    />

    <v-row>
      <v-col cols="2" sm="2" class="coldot">
        <div
          v-bind:class="{
            'text-center': true,
            dot: true,
            dotGreen: has_lowercase,
          }"
        >
          <h1>a</h1>
        </div>
        <p>{{ $t('password.changeDialog.rules.lowercase') }}</p>
      </v-col>
      <v-col cols="2" md="2" class="coldot">
        <div
          v-bind:class="{
            'text-center': true,
            dot: true,
            dotGreen: has_uppercase,
          }"
        >
          <h1>A</h1>
        </div>
        <p>{{ $t('password.changeDialog.rules.uppercase') }}</p>
      </v-col>

      <v-col cols="2" md="2" class="coldot">
        <div
          v-bind:class="{
            'text-center': true,
            dot: true,
            dotGreen: has_number,
          }"
        >
          <h1>0-9</h1>
        </div>
        <p>{{ $t('password.changeDialog.rules.digit') }}</p>
      </v-col>

      <v-col cols="2" md="2" class="coldot">
        <div
          v-bind:class="{
            'text-center': true,
            dot: true,
            dotGreen: has_lenght,
          }"
        >
          <h1>8+</h1>
        </div>
        <p>{{ $t('password.changeDialog.rules.caracters') }}</p>
      </v-col>
      <v-col cols="2" md="2" class="coldot">
        <div
          v-bind:class="{
            'text-center': true,
            dot: true,
            dotGreen: has_special,
          }"
        >
          <h1>/$</h1>
        </div>
        <p>{{ $t('password.changeDialog.rules.special') }}</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ErrorServeur from '@/plugins/mixins/ErrorServeur'
import ValidationRules from '@/plugins/mixins/ValidationRules'

export default {
  mixins: [ErrorServeur, ValidationRules],
  provide() {
    return {
      $vroot: this.$v,
    }
  },
  data() {
    return {
      enum: {},
      passwordRule: () =>
        this.password_check() || this.$t('errors.passwordRegles'),
      confirmationRule: () =>
        this.newPassword == this.confirmNewPassword ||
        this.$t('errors.missmatch'),
      validate: false,
      readonly: true,
      newPassword: null,
      has_number: false,
      has_lowercase: false,
      has_uppercase: false,
      has_special: false,
      has_lenght: false,
      confirmNewPassword: null,
      show3: false,
      show2: false,
    }
  },
  created() {},
  mounted() {},
  computed: {},
  watch: {
    newPassword(val) {
      this.$emit('emitPassword', val)
    },
    confirmNewPassword(val) {
      this.$emit('emitConfirmation', val)
    },
  },
  methods: {
    password_check: function () {
      if (this.newPassword != null) {
        this.has_number = /\d/.test(this.newPassword)
        this.has_lowercase = /[a-z]/.test(this.newPassword)
        this.has_uppercase = /[A-Z]/.test(this.newPassword)
        this.has_special = /[\\\\!@#$%^\\[&*)(+=._\-{}'"\],/:;<=>?`|~£]/.test(
          this.newPassword,
        )
        this.has_lenght = this.newPassword.length >= 8

        return (
          this.has_number &&
          this.has_lowercase &&
          this.has_uppercase &&
          this.has_special &&
          this.has_lenght
        )
      } else {
        return false
      }
    },
    resetForm() {
      this.newPassword = null
      this.confirmNewPassword = null
    },
  },

  validations: {},
}
</script>

<style>
.dot {
  margin-left: calc(41% - 25px);
  max-width: 90px;
  min-width: 40px;
  max-height: 45px;
  min-height: 25px;
  /* background-color: gold; */
  border-top-left-radius: 45px;
  border-top-right-radius: 45px;
  position: relative;
}
.dot > h1 {
  bottom: 0;
  position: absolute;
  font-size: 1rem;
  width: 100%;
}
.dotGreen {
  border: 3px solid green;
  border-bottom: 0;
}

.dotGreen > h1 {
  color: blue;
}
.coldot > p {
  text-align: center;
}
</style>
